import check from '@/plugins/check'

export default {
  inserted(el, binding, vnode) {
    if (check.isVip()) {
      console.log('vip')
    } else {
      console.log('no vip')
    }
  },
}
